export default {
  data: function () {
    return {
      isTablet: false,
    }
  },
  mounted() {
    this.checkWindowSize()
    window.addEventListener('resize', this.checkWindowSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkWindowSize)
  },
  methods: {
    checkWindowSize() {
      this.isTablet = window.innerWidth <= 720
    },
  },
}
